module.exports = __webpack_public_path__ + "static/media/whatWeDo.4b974ce6.png";